import styled from 'styled-components';

import {Texto} from './Utils';

const CardContainer =  styled.div`
    display: flex;
    align-items:center;
    border:"1px solid silver";
    margin:'1rem';
    padding: '.5rem';
    box-shadow: "1px 1px 4px 1px silver";
    background: white;
    margin: 1rem 0;
    padding: .3rem .6rem ;
    box-shadow: 2px 2px 2px rgb(0 0 0 / 5%);

    img{
        max-width: ${props => props?.imgSize ? props.imgSize : "70px"};
        border: 1px solid green;
        padding: .2rem;
        border-radius: 50%;
    }
`;

const CardPessoa = ({nome, email, img, className, imgSize}) => {
	return(
		<CardContainer className={className} imgSize={imgSize}>
            <img src={img}  />
            <div className="ml-2">
                <Texto className="m-0" tamanho="100%" cor="#555">{nome}</Texto>
                <Texto className="m-0" tamanho="75%" cor="#aaa">{email}</Texto>
            </div>
        </CardContainer>
	)
}

export default CardPessoa
